module.exports = __webpack_public_path__ + "static/media/project_4.a552f73d.webp";